export function sendMessage1(db, name, email, message) {
    db.doc(name).set({
        name: name,
        email: email,
        message: message,
    });
}
